import React from 'react';
import { Link } from 'react-router-dom';
import { avatarColor, initials } from './brand';
import { fullUrl } from '../../api';

/**
 * Member avatar (image or coloured initials). When `to` is given the avatar
 * links to that member's community profile.
 */
export default function UserAvatar({ user, size = 40, className = '', to = null, ring = false }) {
  const name = user?.name || user?.username || '?';
  const src = user?.avatar ? fullUrl(user.avatar) : '';
  const box = {
    width: size,
    height: size,
    background: src ? '#e5e7eb' : avatarColor(user?.username || name),
    fontSize: Math.max(11, Math.round(size / 2.6)),
  };

  const inner = (
    <span
      className={`inline-flex items-center justify-center rounded-full overflow-hidden font-bold text-white shrink-0 ${ring ? 'ring-2 ring-white shadow' : ''} ${className}`}
      style={box}
      title={name}
    >
      {src ? (
        <img src={src} alt={name} className="w-full h-full object-cover" loading="lazy" />
      ) : (
        initials(name)
      )}
    </span>
  );

  if (to) return <Link to={to} className="shrink-0">{inner}</Link>;
  return inner;
}
